import { inject, provide, ref } from "vue";
import { v4 as uuidv4 } from "uuid";
export const MODAL_KEY = Symbol("modal");
export const provideModal = () => {
    const modalStack = ref([]);
    /**
     * @description 모달 열기
     * @param name 모달 이름
     * @param props 모달 속성
     */
    const open = (name, props) => {
        const id = uuidv4();
        modalStack.value.push({ id, name, props });
        return id;
    };
    /**
     * @description 모달 열기 (중복 모달 방지)
     * @param name 모달 컴포넌트 이름, e.g. MemberSearchDialog
     * @param props 모달 컴포넌트 속성, e.g. { setMember, onClose }
     */
    const openExclusive = (name, props) => {
        modalStack.value = [];
        return open(name, props);
    };
    /**
     * @description 모달 닫기
     * @param id 모달 아이디
     */
    const close = (id) => {
        modalStack.value = modalStack.value.filter((m) => m.id !== id);
    };
    /**
     * @description 모든 모달 닫기
     */
    const closeAll = () => {
        modalStack.value = [];
    };
    /**
     * @description 확인 모달 열기
     * @param props 모달 컴포넌트 속성, e.g. { onConfirm, onCancel }
     */
    const confirm = (props) => new Promise((resolve) => {
        const id = open("ConfirmModal", {
            ...props,
            // 모달 컴포넌트가 이 콜백들을 props로 받아 실행
            onConfirm: () => {
                resolve(true);
                close(id);
            },
            onCancel: () => {
                resolve(false);
                close(id);
            },
        });
    });
    const ctx = {
        modalStack,
        open,
        openExclusive,
        close,
        closeAll,
        confirm,
    };
    provide(MODAL_KEY, ctx);
    return ctx;
};
export const useModal = () => {
    const ctx = inject(MODAL_KEY);
    if (!ctx) {
        throw new Error("Page 루트에서 provideModalManager() 먼저 호출하세요.");
    }
    return ctx;
};
